import { FunctionComponent, useEffect, useLayoutEffect, useState } from "react";
import StarIcon from "@mui/icons-material/Star"; // Import a star icon from MUI
import "./InstructionReExam.scss";
import { Outlet, useLocation, useNavigate } from "react-router-dom";
import { useAppDispatch, useAppSelector } from "../../Redux/Store/Hooks";
import { listExamID } from "../../Redux/Slices/Exam/ListExamIDSlice";
import { addStudentExam } from "../../Redux/Slices/StudentExam/AddStudentExamSlice";
import { decode } from "../../Utils/encodeDecode";
import { ILoginResponse } from "../Login/ILogin";
import { clearListReExamID, listReExamID } from "../../Redux/Slices/ReExam/ListReExamSlice";
import FiberManualRecordIcon from "@mui/icons-material/FiberManualRecord";
import { addOpenSection, clearAddOpenSectionResponse } from "../../Redux/Slices/OpenSection/AddOpenSectionSlice";
import {
  AppBar,
  Box,
  Button,
  Card,
  CardContent,
  CssBaseline,
  Grid,
  SvgIcon,
  Toolbar,
  Typography,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import AppBarnav from "../../Components/AppBar/AppBar";
import {
  clearlistStudentExam,
  listStudentExam,
} from "../../Redux/Slices/StudentExam/ListStudentExamSlice";
import InfoIcon from "@mui/icons-material/Info";
import { CircularProgress } from "@mui/material";
import { ReactComponent as Logo } from "../../Assets/Images/loginlogo.svg";
import AccessTimeIcon from "@mui/icons-material/AccessTime";
import TaskAltIcon from "@mui/icons-material/TaskAlt";
import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
import timezone from "dayjs/plugin/timezone";

interface InstructionReExamProps { }

const InstructionReExam: FunctionComponent<InstructionReExamProps> = () => {
  // Create an array of instruction objects
  const navigate = useNavigate();
  const { state: exam_id } = useLocation();
  dayjs.extend(utc);
  dayjs.extend(timezone);

  const offsetMinutes = dayjs().tz(dayjs.tz.guess()).utcOffset();

  const { data: listexamlist, isLoading: listexamlistLoading } = useAppSelector(
    (state) => state.ListReExamIDSlice
  );
  const InstructionReExamlist: any = listexamlist?.data;
  const dispatch = useAppDispatch();



  const { data: listStudentExamSlice } = useAppSelector(
    (state) => state.ListStudentExamSlice
  );
  const ListStudentExam: any = listStudentExamSlice?.data;

  const { data: AddStudent } = useAppSelector(
    (state) => state.AddStudentExamSlice
  );
  const StuentAdd = AddStudent?.data;

  const { isLoading: addOpenSectionLoading, data: addOpenSectionData } = useAppSelector(
    (state) => state.AddOpenSectionSlice
  );

  const [isNavigating, setIsNavigating] = useState(false);
  const [retakeData, setRetakeData] = useState<any>(null);

  const [details, setDetails] = useState<ILoginResponse>({});

  const finalInstructionReExam = retakeData?.exam_instruction;

  useLayoutEffect(() => {
    dispatch(clearListReExamID());
    dispatch(clearlistStudentExam()); // Clear student exam list to prevent stale ID usage
    dispatch(clearAddOpenSectionResponse());
  }, []);

  useEffect(() => {
    if (exam_id) {
      dispatch(listReExamID({ id: exam_id }));
    }
  }, [exam_id]);

  useEffect(() => {
    if (InstructionReExamlist) {
      setRetakeData(InstructionReExamlist);
    }
  }, [InstructionReExamlist]);

  useEffect(() => {
    if (StuentAdd) {
      dispatch(listStudentExam());
    }
  }, [StuentAdd]);

  useEffect(() => {
    const userDetails = decode(sessionStorage.getItem("details"));
    setDetails(userDetails);
  }, []);

  const handleButtonClick = () => {
    setIsNavigating(true);

    // Step 1: Trigger retake API and get question payload
    if (retakeData) {
      // Step 2: Create student exam with the retake questions payload
      dispatch(
        addStudentExam({
          exam_id: retakeData?.exam_id,
          student_id: details?.id,
          closed: false,
          questions: retakeData?.questions_by_type,
          client_tz_offset: offsetMinutes,
        })
      );
    }
  };

  useEffect(() => {
    if (AddStudent?.status === true && isNavigating && StuentAdd?.id) {
      // Step 2: After student exam is created, get the student exam list AND fetch the specific re-exam data with the new ID
      dispatch(listStudentExam());
      dispatch(listReExamID({ id: StuentAdd?.id }));
    }
    if (AddStudent?.status === false && isNavigating) {
      setIsNavigating(false);
    }
  }, [AddStudent, isNavigating]);

  useEffect(() => {
    if (ListStudentExam && isNavigating && listexamlist?.status === true && AddStudent?.status === true && StuentAdd?.id) {
      // Step 3: Now we have both the student exam session and the retake data loaded
      sessionStorage.setItem("student_id", details?.id);
      navigate("/reexam", {
        state: { examID: StuentAdd?.id }, // Use the new session ID
      });
      setIsNavigating(false);
    }
  }, [ListStudentExam, isNavigating, listexamlist, navigate, details?.id, StuentAdd?.id, AddStudent]);

  // Removed obsolete Step 5 useEffect

  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  // question count
  const totalQuestionCount = retakeData?.questions_by_type?.reduce(
    (sum: any, item: any) => sum + item.question_count,
    0
  );
  return (
    <>
      <Box sx={{ display: "flex", height: "1px" }}>
        <CssBaseline />
        <AppBar
          position="fixed"
          sx={{
            zIndex: (theme) => theme.zIndex.drawer + 1,
            backgroundColor: "#FFFFFF",
            display: "flex",
            boxShadow: "0px 4px 40px 0px #0000000D",
          }}
        >
          <Toolbar
            sx={{
              minHeight: "0px",
              display: "flex",
              justifyContent: "space-between",
              paddingLeft: "0px",
              paddingRight: "0px",
              margin: "0% 8%",
              height: "50px",
            }}
          >
            <Typography variant="h6" noWrap component="div">
              <SvgIcon
                sx={{
                  width: "123px",
                  height: "50px",
                  marginTop: "10px",
                  cursor: "pointer",
                }}
                color="primary"
                component={Logo}
                inheritViewBox
              />
            </Typography>
            <div style={{ display: "flex", gap: "20px", alignItems: "center" }}>
              <div
                style={{
                  display: "flex",
                  color: "#009dff",
                  fontSize: "16px",
                  alignItems: "center",
                  cursor: "pointer",
                }}
                onClick={() => {
                  navigate("/dashboard"); // Replace with your target route
                }}
              >
                <ArrowBackIosIcon sx={{ color: "#009dff" }} />
                <div style={{ color: "#009dff", fontSize: "15px" }}>
                  {" "}
                  Back To Dashboard
                </div>
              </div>
            </div>
          </Toolbar>
        </AppBar>

        <Box
          component="main"
          sx={{ flexGrow: 1, height: "100vh", width: "100%" }}
        >
          <Outlet />
          {(addOpenSectionLoading || isNavigating) && (
            <Box
              sx={{
                position: "fixed",
                top: 0,
                left: 0,
                right: 0,
                bottom: 0,
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                backgroundColor: "rgba(255, 255, 255, 0.5)",
                zIndex: 9999,
              }}
            >
              <CircularProgress />
            </Box>
          )}
        </Box>
      </Box>

      <Box
        sx={{
          marginTop: "50px",
          backgroundColor: "#f5f9ff",
          minHeight: "100vh",
          py: 5,
          px: 2,
          display: "flex",
          justifyContent: "center",
          alignItems: "flex-start",
        }}
      >
        {listexamlistLoading || !retakeData ? (
          <Box
            sx={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              height: "50vh",
              width: "100%",
            }}
          >
            <CircularProgress />
          </Box>
        ) : (
          <Grid container spacing={4} justifyContent="center" maxWidth="lg">
            <Grid item xs={12}>
              <Typography
                variant="h3"
                fontWeight="bold"
                textAlign="center"
                color="#1e3a8a"
              >
                {retakeData?.exam_name}
              </Typography>
              <Typography
                variant="body1"
                textAlign="center"
                maxWidth="700px"
                mx="auto"
                fontSize="19px"
                mt={1}
                color="#4b5563"
              >
                {retakeData?.description}
              </Typography>
            </Grid>

            {/* Instructions Card */}
            <Grid item xs={12} md={6}>
              <Card
                sx={{
                  p: 2,
                  borderRadius: "12px",
                  boxShadow: "0px 37px 37px rgba(0, 157, 255, 0.1)",
                }}
              >
                <CardContent>
                  <Typography
                    variant="h6"
                    fontWeight="bold"
                    gutterBottom
                    sx={{
                      color: "#111827",
                      fontSize: "1.7rem",
                      marginBottom: "15px",
                    }}
                  >
                    Please Read Instructions Carefully
                  </Typography>

                  <Box mb={2}>
                    {finalInstructionReExam?.map((item: any, index: any) => (
                      <Typography variant="body1" key={index} gutterBottom>
                        {/* <div key={index} className="instructionitem"> */}

                        <div
                          style={{
                            fontSize: "18px",
                            marginBottom: "20px",
                            display: "flex",
                            alignItems: "center",
                            gap: "10px",
                          }}
                        >
                          <span
                            style={{
                              height: "20px",
                              // width: "20px",
                              backgroundColor: "#009dff",
                              color: "#374151",
                              borderRadius: "50%",
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center",
                              padding: "9px",
                              // marginRight: "8px",
                            }}
                          >
                            <span
                              style={{
                                height: "4px",
                                width: "4px",
                                backgroundColor: "#ffffff",
                                borderRadius: "50%",
                                display: "inline-block",
                              }}
                            />
                          </span>

                          {item?.instruction}
                        </div>
                      </Typography>
                    ))}
                  </Box>

                  {retakeData ? (
                    <Box
                      display="flex"
                      gap={2}
                      flexDirection={isMobile ? "column" : "row"}
                    >
                      <Button
                        variant="contained"
                        color="primary"
                        fullWidth
                        sx={{
                          textTransform: "capitalize",
                          fontSize: "17px",
                          color: "white",
                          "&:hover": {
                            backgroundColor: "#009dff",
                          },
                        }}
                        onClick={handleButtonClick}
                      >
                        Start Test
                      </Button>
                      <Button
                        variant="outlined"
                        color="primary"
                        fullWidth
                        sx={{
                          textTransform: "capitalize",
                          fontSize: "17px",
                          backgroundColor: "white",
                          color: "#009dff",
                          borderColor: "#009dff",
                          "&:hover": {
                            borderColor: "#009dff",

                            backgroundColor: "white",
                            color: "#009dff",
                          },
                        }}
                        onClick={() => {
                          navigate("/dashboard"); // Replace with your target route
                        }}
                      >
                        Back To Home
                      </Button>
                    </Box>
                  ) : (
                    <>
                      <Button
                        variant="contained"
                        color="primary"
                        fullWidth
                        disabled={true}
                        onClick={handleButtonClick}
                        sx={{
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          textTransform: "capitalize",
                          fontSize: "17px",
                          color: "white",

                          "&:hover": {
                            backgroundColor: "#009dff",
                            color: "white",
                          },
                        }}
                      >
                        <div>Loading questions</div>
                        <div>
                          <CircularProgress
                            size={20}
                            sx={{
                              color: "white",
                              marginLeft: "10px",
                            }}
                          />
                        </div>
                      </Button>
                      <div className="vaidationforwriting">
                        <InfoIcon />
                        <div>
                          Please wait while the questions are being prepared. The
                          test will begin shortly{" "}
                        </div>
                      </div>
                    </>
                  )}
                </CardContent>
              </Card>
            </Grid>

            {/* Test Includes Card */}
            <Grid item xs={12} md={3}>
              <Card
                sx={{
                  // p: 2,
                  borderRadius: "12px",
                  backgroundColor: "#f5faff",
                  boxShadow: "0px 37px 37px rgba(0, 157, 255, 0.1)",
                  border: "1px solid #e0f0ff",
                }}
              >
                <CardContent>
                  <Typography
                    variant="h6"
                    fontWeight="bold"
                    gutterBottom
                    sx={{ color: "#111827", fontSize: "1.7rem" }}
                  >
                    Exam Includes
                  </Typography>

                  {retakeData?.questions_by_type.map((item: any) => (
                    <Box
                      key={item.question_type_id}
                      sx={{
                        p: 2,
                        borderRadius: "10px",
                        backgroundColor: "white",
                        mb: 2,
                        border: "1px solid #dceeff",
                      }}
                    >
                      <Typography sx={{ fontWeight: "bold", fontSize: "1.3rem" }}>
                        {item.question_type_name}
                      </Typography>

                      <Typography
                        variant="body2"
                        sx={{
                          mt: 1,
                          display: "flex",
                          justifyContent: "space-between",
                          fontSize: "1.3rem",
                          alignItems: "center",
                        }}
                      >
                        <span style={{ color: "#4B5563", fontSize: "1.3rem" }}>
                          Question type:
                        </span>
                        <div style={{ fontWeight: 500, color: "black" }}>
                          {item.question_type_name === "Writing"
                            ? "Written"
                            : "MCQ"}
                        </div>
                      </Typography>

                      <Typography
                        variant="body2"
                        sx={{
                          mt: 1,
                          display: "flex",
                          justifyContent: "space-between",
                          fontSize: "1.3rem",
                          alignItems: "center",
                        }}
                      >
                        <span style={{ color: "#4B5563", fontSize: "1.3rem" }}>
                          Question count:
                        </span>
                        <div style={{ fontWeight: 500, color: "black" }}>
                          {item.question_count}
                        </div>
                      </Typography>

                      <Typography
                        variant="body2"
                        sx={{
                          mt: 1,
                          display: "flex",
                          justifyContent: "space-between",
                          fontSize: "1.3rem",
                          alignItems: "center",
                        }}
                      >
                        <span style={{ color: "#4B5563", fontSize: "1.3rem" }}>
                          Duration:
                        </span>
                        <div style={{ fontWeight: 500, color: "black" }}>
                          {item.duration}
                        </div>
                      </Typography>
                    </Box>
                  ))}

                  <Box
                    sx={{
                      borderTop: "1px solid #e0e0e0",
                      pt: 2,
                      display: "flex",
                      justifyContent: "space-around",
                      flexWrap: "wrap",
                    }}
                  >
                    <Box display="flex" alignItems="center" gap={1} mb={1}>
                      <Box
                        sx={{
                          display: "flex",
                          flexDirection: "column",
                          alignItems: "center",
                        }}
                      >
                        <div>
                          {" "}
                          <AccessTimeIcon
                            sx={{ color: "#009DFF", fontSize: "3rem" }}
                          />
                        </div>
                        <Typography
                          variant="caption"
                          sx={{ color: "#666", fontSize: "1rem" }}
                        >
                          TOTAL DURATION
                        </Typography>
                        <Typography
                          fontWeight="bold"
                          variant="body2"
                          sx={{ fontSize: "1.2rem" }}
                        >
                          {retakeData?.total_timing}
                        </Typography>
                      </Box>
                    </Box>

                    <Box display="flex" alignItems="center" gap={1} mb={1}>
                      <Box
                        sx={{
                          display: "flex",
                          flexDirection: "column",
                          alignItems: "center",
                        }}
                      >
                        <div>
                          <TaskAltIcon
                            sx={{ color: "#009DFF", fontSize: "3rem" }}
                          />
                        </div>

                        <Typography
                          variant="caption"
                          sx={{ color: "#666", fontSize: "1rem" }}
                        >
                          QUESTIONS
                        </Typography>
                        <Typography
                          fontWeight="bold"
                          variant="body2"
                          sx={{ fontSize: "1.2rem" }}
                        >
                          {totalQuestionCount ?? "-"}
                        </Typography>
                      </Box>
                    </Box>
                  </Box>
                </CardContent>
              </Card>
            </Grid>
          </Grid>
        )}
      </Box>
    </>
  );
};

export default InstructionReExam;
